import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody43';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy41 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Standard Operating Procedures  </h2><h4>Finance & Accounting SOP Framework for an ultra-luxury hospitality group</h4>";

  return (
    <>
        <Helmet>
        <title>Standard Operating Procedures Finance & Accounting SOP Framework for an ultra-luxury hospitality group</title>
        <meta property="og:title" content="Standard Operating Procedures Finance & Accounting SOP Framework for an ultra-luxury hospitality group" />
        <meta property='og:description' content='Standard Operating Procedures Finance & Accounting SOP Framework for an ultra-luxury hospitality group'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy41" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy41
